import { render, staticRenderFns } from "./SvWorkRegistrationModulePanel.vue?vue&type=template&id=b1edc7b6"
import script from "./SvWorkRegistrationModulePanel.vue?vue&type=script&lang=js"
export * from "./SvWorkRegistrationModulePanel.vue?vue&type=script&lang=js"
import style0 from "./SvWorkRegistrationModulePanel.vue?vue&type=style&index=0&id=b1edc7b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports